import PropTypes from "prop-types";
import { IconButton, Tooltip, Switch, FormControlLabel } from "@mui/material";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import { useICCCColors } from "../components/theme";

export default function MapToolbar({ onZoomIn, onZoomOut, onReset, editable, onEditableChange }) {
  const ICCC_COLORS = useICCCColors();

  const iconButtonSx = {
    color: ICCC_COLORS.textSecondary,
    "&:hover": { bgcolor: ICCC_COLORS.hoverBg },
    "&.Mui-disabled": { color: ICCC_COLORS.textDim },
  };

  return (
    <MDBox
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        bgcolor: ICCC_COLORS.cardBg,
        border: `1px solid ${ICCC_COLORS.cardBorder}`,
        borderRadius: 999,
        pl: 1.5,
        pr: 1,
        py: 0.5,
        boxShadow: ICCC_COLORS.shadow,
      }}
    >
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={editable}
            onChange={(e) => onEditableChange(e.target.checked)}
            color="warning"
            sx={{
              // Thumb stays white in both states; only the track colour flips
              // (grey = off, amber = on). The checked track colour must be set
              // explicitly, otherwise the base track rule below keeps it grey
              // and on/off look identical.
              "& .MuiSwitch-thumb": {
                bgcolor: "#fff",
              },
              "& .MuiSwitch-track": {
                bgcolor: ICCC_COLORS.textDim,
                opacity: 1,
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                bgcolor: ICCC_COLORS.warning,
                opacity: 1,
              },
            }}
          />
        }
        label="Edit layout"
        sx={{
          m: 0,
          "& .MuiFormControlLabel-label": {
            fontSize: 12,
            fontWeight: 600,
            color: ICCC_COLORS.textSecondary,
            whiteSpace: "nowrap",
          },
        }}
      />
      <MDBox
        sx={{
          width: "1px",
          alignSelf: "stretch",
          my: 0.5,
          bgcolor: ICCC_COLORS.cardBorder,
        }}
      />
      <Tooltip title={editable ? "Zoom out" : "Enable Edit layout to zoom"}>
        <span>
          <IconButton size="small" disabled={!editable} onClick={onZoomOut} sx={iconButtonSx}>
            <Icon fontSize="small">remove</Icon>
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={editable ? "Zoom in" : "Enable Edit layout to zoom"}>
        <span>
          <IconButton size="small" disabled={!editable} onClick={onZoomIn} sx={iconButtonSx}>
            <Icon fontSize="small">add</Icon>
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={editable ? "Reset view" : "Enable Edit layout to reset zoom"}>
        <span>
          <IconButton size="small" disabled={!editable} onClick={onReset} sx={iconButtonSx}>
            <Icon fontSize="small">center_focus_strong</Icon>
          </IconButton>
        </span>
      </Tooltip>
    </MDBox>
  );
}

MapToolbar.propTypes = {
  onZoomIn: PropTypes.func.isRequired,
  onZoomOut: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  onEditableChange: PropTypes.func.isRequired,
};

MapToolbar.defaultProps = {
  editable: false,
};
